// src/components/RetentionWorksheet.js
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import AdvanceSearch from "../../../CommonComponents/AdvanceSearch";
import {
  Accordion,
  AccordionDetails,
  Box,
  Button,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import TelerikDataTable from "../../../CommonComponents/TelerikDataTable";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAuth } from "oidc-react";
import visibleColumns from "./visibleColumns";
import useSortedColumns from "../../../utils/useSortedColumns";
import { advanceSearch } from "../../../_helper/services/advanceSearchv2";
import { Btn } from "../../../AbstractElements";
import { faPlus } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RetentionForm from "./RetentionForm";

const RetentionWorksheet = ({ modalData, departmentOptions,adHocPoint, setAdHocPoint }) => {
  const id = "RetentionListDetail";

  const {
    columns,
    loadingSearch,
    searchResults,
    ColumnsSorted,
    searchParameter,
    // searchResults: { results, rowCount },
    searchResultsV2,
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const { [id]: { results = [], rowCount } = {} } = searchResultsV2 || {};
  const navigate = useNavigate();
  const { userData } = useAuth();
  // const [expandedSearchResult, setexpandedSearchResult] = useState(false);

  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [searchParams, setSearchParams] = useState([
    {
      columnName: "EmployeeID",
      value: modalData?.EmpNo ?? 0,
      operator: "=",
      dataType: "bigint",
      logicOperator: "AND",
    },
  ]);

  const [serviceData, setServiceData] = useState({
    Days: 0,
    Months: 0,
    Years: 0,
  });

  const [modifiedModalData,setModifiedModalData] = useState(modalData);
  console.log('adHocPoint',adHocPoint);
  const { Years, Months, Days } = serviceData
  const totalService = (Years) * 12 + (Months)
  const retentionScore = (Years) * 12 + (Months) + modifiedModalData?.PerformancePoint;

  const [page, setPage] = useState(1);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [sortData, setSortData] = useState([
    // {field:"Step_Actual",dir:"DESC"}
    // { field: "Current_DepartmentName", dir: "asc" },
    // { field: "Action_Type", dir: "asc"},
    // { field: "Action_Effective_Date", dir: "asc" }
  ]);
  const [pageSize, setPageSize] = useState(100);
  const [addRecordModal, setAddRecordModal] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notificationId, setNotificationId] = useState(null);
  const [defaultAdditionalWhere, setDefaultAdditionalWhere] = useState("");
  const [callApiAgain,setcallApiAgain] = useState(false)
  const [remarksOpen,setRemarksOpen] = useState(false)
  const [remarksData,setRemarksData] = useState("")
  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);
  useEffect(() => {
    // console.log(searchResults);
  }, [searchResults]);
  const [sortedColumns, setSortedColumns] = useSortedColumns(
    id,
    ColumnsSorted,
    columns,
    visibleColumns,
    userData
  );

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    // setPage(1);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };
  useEffect(() => {
    if (searchParameter[id]?.searchParams?.length > 0) {
      setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
    }
  }, [searchParameter]);
  useEffect(()=>{
    setModifiedModalData(Object.assign(modifiedModalData,{PerformancePoint: modifiedModalData?.PerformancePoint + adHocPoint}));
    
  },[adHocPoint]);

  const getCalculationData = async () => {
    const payload = {
      tableName: "fn_CalculateEmploymentDuration",
      searchParams: `[{\"columnName\":\"EmploymentDate\",\"value\":\"${modalData?.EmploymentDate}\",\"operator\":\"=\",\"dataType\":\"DATETIME\",\"logicOperator\":\"AND\"}]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 100,
      sortData: "",
      additionalWhere: "",
      qID: 0,
      role: "",
      location: "global",
      id: "CalculateEmploymentDuration",
    };
    try {
      const response = await advanceSearch(payload);
      const { results } = response ?? { results: [] };
      if (results?.length > 0) {
        debugger;
        const {Ps_Mm,Ps_Yy} = modalData;
        let data = results[0];
        const addUpMonths = data.Months + Ps_Mm
        const realMonths = (addUpMonths)%12
        data.Years = data.Years + Ps_Yy + Math.floor(addUpMonths/12);
        data.Months = realMonths;
        setServiceData(data);
      }
      console.log(response, "response1221");
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    getCalculationData();
  }, []);

  const formatDate = (stringDate) => {
    const date = new Date(stringDate ?? "2012-04-16T00:00:00");
    const options = {
      weekday: "long",
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(
      date
    );
    return formattedDate;
  };

  const handleClose = () => {
    setAddRecordModal(false);
  };

  const refreshDetail = () => {
    setcallApiAgain(!callApiAgain)
  }

  const showRemarks = (remarks) => {
    handleRemarksOpen()
    setRemarksData(remarks)
  }

  const handleRemarksOpen = () => setRemarksOpen(true);
  const handleRemarksClose = () => setRemarksOpen(false);

  
  const GetPayloadWithColumnTitle = (payloadcolumns) => {
    const tempcolumns = [...columns];
    const payloadArray = [];
    for (let i of payloadcolumns) {
      for (let tempcolum of tempcolumns) {
        if (i.ColumnName == tempcolum.column_name) {
          let obj = {
            ColumnName: tempcolum.column_title,
            Aliginment: i.Aliginment,
          };
          payloadArray.push(obj);
        }
      }
    }
    if (payloadArray.length) {
      return JSON.stringify(payloadArray);
    } else {
      return "[]";
    }
  };
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
      }}
    >
      <h3
        style={{
          textAlign: "center",
          margin: "0 0 20px 0",
          fontSize: "16px",
          textDecoration: "underline",
        }}
      >
        RETENTION WORKSHEET AUDIT - {modalData?.EmployeeName ?? ""}
      </h3>

      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          <p style={{ margin: "2px 0" }}>
            <strong>CURRENT TITLE:</strong> {results?.[0]?.Position ?? ""}
          </p>
          <p style={{ margin: "2px 0" }}>
            <strong>EMPL SSN:</strong>{" "}
            {results?.[0]?.Social_Security_Number ?? ""}
          </p>
          <p style={{ margin: "2px 0" }}>
            <strong>EMPL JACKET NO:</strong> {results?.[0]?.JacketNo ?? ""}
          </p>
        </div>
        <div>
          <p style={{ margin: "2px 0", textAlign: "right" }}>
            <strong>POSITION GROUPING</strong>
          </p>
          <p style={{ margin: "2px 0", textAlign: "right" }}>
            {""} &nbsp;&nbsp;&nbsp; {""} &nbsp;&nbsp;&nbsp; {""}
          </p>
        </div>
      </div>

      {/* <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
        <thead>
          <tr>
            <th style={headerStyle}>SL DT</th>
            <th style={headerStyle}>Position Title</th>
            <th style={headerStyle}>Department</th>
            <th style={headerStyle}>Grade-Step</th>
            <th style={headerStyle}>Rating</th>
            <th style={headerStyle}>Score</th>
          </tr>
        </thead>
        <tbody>
          {[
            { date: "9/29/2021", title: "PERSONNEL SPECIALIST IV", department: "DOA", grade: "O-10", rating: "O", score: 4 },
            { date: "3/29/2020", title: "PERSONNEL SPECIALIST IV", department: "DOA", grade: "O-10", rating: "O", score: 4 },
            { date: "3/29/2019", title: "PERSONNEL SPECIALIST IV", department: "DOA", grade: "O-9", rating: "O", score: 4 },
            { date: "3/29/2018", title: "PERSONNEL SPECIALIST IV", department: "DOA", grade: "O-9", rating: "O", score: 4 },
            { date: "3/29/2017", title: "PERSONNEL SPECIALIST IV", department: "DOA", grade: "O-8", rating: "O", score: 4 },
            { date: "3/29/2016", title: "PERSONNEL SPECIALIST IV", department: "DOA", grade: "O-8", rating: "O", score: 4 },
            { date: "9/29/2005", title: "PERSONNEL SPECIALIST I", department: "DOA", grade: "K-03", rating: "O", score: 2 },
          ].map((row, index) => (
            <tr key={index}>
              <td style={cellStyle}>{row.date}</td>
              <td style={cellStyle}>{row.title}</td>
              <td style={cellStyle}>{row.department}</td>
              <td style={cellStyle}>{row.grade}</td>
              <td style={cellStyle}>{row.rating}</td>
              <td style={cellStyle}>{row.score}</td>
            </tr>
          ))}
        </tbody>
      </table> */}
      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
        <Btn
          attrBtn={{
            color: "primary",
            onClick: (e) => {
              e.stopPropagation();
              setAddRecordModal(true);
              // setOpen({ ...open, selectOpen: !open.selectOpen });
            },
            style: { marginLeft: "20px", marginBottom: "10px" },
          }}
        >
          <FontAwesomeIcon icon={faPlus} /> Adhoc
        </Btn>
      </div>

      <Row>
        <Col sm="12" className="page-content">
          <Card>
            <CardBody>
              <AdvanceSearch
                id={id}
                gridId={id}
                location="global"
                columnList={"*"}
                columnRefernces={[]}
                tableName={"fn_RetentionDetails"}
                searchParams={searchParams}
                additionalWhere={additionalWhere}
                expanded={false}
                sortData={sortData}
                pageNumber={page}
                pageSize={pageSize}
                chooseFilterMethod={chooseFilterMethod}
                callApiAgain={callApiAgain}
              />

              <Accordion expanded={expandedSearchResult}>
                <AccordionDetails>
                  {/* {loadingSearch && loadingPanel} */}
                  <div>
                    {sortedColumns.length > 0 && (
                      <TelerikDataTable
                        key={id}
                        id={id}
                        pageSize={pageSize}
                        totalCount={rowCount}
                        skip={(page - 1) * pageSize}
                        take={pageSize}
                        data={results || []}
                        sortData={sortData}
                        onFilterChange={handleFilterChange}
                        onSortChange={handleSortChange}
                        onPageChange={handlePageChange}
                        onPageSizeChange={handlePageSizeChange}
                        selectedColumns={sortedColumns}
                        setSortedColumns={setSortedColumns}
                        isDashboard={true}
                        hideSaveIcon={true}
                        adhoc={true}
                        showRemarks={showRemarks}
                        // actions={actions}
                        // searchParams={searchParams}
                        // setChooseFilterMethod={setChooseFilterMethod}
                        // chooseFilterMethod={chooseFilterMethod}
                        // group={[{ field: "Current_DepartmentName" }]}
                        // defaultAdditionalWhere={defaultAdditionalWhere}
                        additionalExportPdfPayload={{
                          columnAlignments: GetPayloadWithColumnTitle([
                            { ColumnName: "GradenStep", Aliginment: "center" },
                            { ColumnName: "Rating", Aliginment: "right" },
                            { ColumnName: "Score", Aliginment: "right" }
                          ]),
                          headerAliginment: GetPayloadWithColumnTitle([
                            { ColumnName: "GradenStep", Aliginment: "center" },
                            { ColumnName: "Rating", Aliginment: "right" },
                            { ColumnName: "Score", Aliginment: "right" }
                          ]),
                          // columnAlignments:
                          //   '[{"ColumnName":"Grade/step","Aliginment":"center"},{"ColumnName":"Rating","Aliginment":"right"},{"ColumnName":"Score","Aliginment":"right"}]',
                          // headerAliginment:
                          //   '[{"ColumnName":"Grade/step","Aliginment":"center"},{"ColumnName":"Rating","Aliginment":"right"},{"ColumnName":"Score","Aliginment":"right"}]',
                          // "width": [
                          //   {"ColumnName": "Position", "Width": 15},
                          //   {"ColumnName": "Department Name", "Width": 20},
                          //   {"ColumnName": "HOC", "Width": 5},
                          //   {"ColumnName": "Grade/step", "Width": 5},
                          //   {"ColumnName": "Rating", "Width": 5},
                          //   {"ColumnName": "Salary Inc. Date", "Width": 10},
                          //   {"ColumnName": "Score", "Width": 8}
                          // ],
                          
                        "width": "[{\"ColumnName\": \"Position\", \"Width\": 15}, {\"ColumnName\": \"Department Name\", \"Width\": 30},{\"ColumnName\": \"Adhoc\", \"Width\": 5}, {\"ColumnName\": \"Grade/step\", \"Width\": 8},{\"ColumnName\": \"Rating\", \"Width\": 5},{\"ColumnName\": \"Salary Inc. Date\", \"Width\":10},{\"ColumnName\": \"Score\", \"Width\": 5}]"
                        
                        }}
                        header={true}
                        headerContent={`<table style="width: 100%; border-collapse: collapse;">
  <tr>
    <td style="padding: 2px;">
      <p style="margin: 2px 0;"><strong>CURRENT TITLE:</strong> ${
        results?.[0]?.Position ?? ""
      }</p>
    </td>
    <td style="padding: 2px; text-align: right;" colspan=2>
      <p style="margin: 2px 0;"><strong>POSITION GROUPING &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong></p>
    </td>
  </tr>
  <tr>
    <td style="padding: 2px;">
      <p style="margin: 2px 0;"><strong>EMPL SSN:</strong> ${
        results?.[0]?.Social_Security_Number ?? ""
      }</p>
    </td>
    <td style="padding: 2px; margin-left: -20px;">
      <p style="margin: 2px 0;"><strong>EMPL JACKET NO:</strong> ${
        results?.[0]?.JacketNo ?? ""
      }</p>
    </td>
    <td style="padding: 2px; text-align: right;">
      <p style="margin: 2px 0;">${""} &nbsp;&nbsp;&nbsp; ${""} &nbsp;&nbsp;&nbsp; ${""}</p>
    </td>
  </tr>
</table>
`}
                        footerContent={`<table style="border: 1px solid #000; width: 100%; padding: 10px; border-collapse: collapse;">
  <tr style="border: 1px solid #000;">
    <td style="padding: 5px;">
      <strong>Prior Mil:</strong> ${results?.[0]?.Psmil_Yy ?? 0} Years ${
                          results?.[0]?.Psmil_Mm ?? 0
                        } Months ${results?.[0]?.Psmil_Dd ?? 0} Days
    </td>
    <td style="padding: 5px;">
      <strong>Prior GovGuam Service:</strong> ${
        results?.[0]?.Ps_Yy ?? 0
      } Years ${results?.[0]?.Ps_Mm ?? 0} Months ${
                          results?.[0]?.Ps_Dd ?? 0
                        } Days
    </td>
  </tr>
</table>

<div style="height: 1px; width:650px; background-color: #000; margin:10px 0;"></div>

<table style="border: 1px solid #000; width: 100%; padding: 10px; border-collapse: collapse; margin-top: 10px;">
  <tr style="border: 1px solid #000; text-align: center;">
    <td style="padding: 5px;">
      <strong>Total Actual GovGuam Service:</strong> ${
        serviceData?.Years
      } Years ${serviceData?.Months} Months ${serviceData?.Days} Days
    </td>
  </tr>
</table>

<div style="margin-bottom: 20px;">
  <p style="margin: 2px 0;"><strong>EMPLOYMENT DATE:</strong> ${formatDate(
    modalData?.EmploymentDate
  )}</p>
  <p style="margin: 2px 0;"><strong>Total Service Points:</strong> ${
    totalService
  }</p>
  <p style="margin: 2px 0;"><strong>Total Performance Points:</strong> ${
    modifiedModalData?.PerformancePoint
  }</p>
  <p style="margin: 2px 0;"><strong>Total Retention Points:</strong> ${retentionScore}</p>
</div>

<table style="border: 1px solid #000; width: 100%; border-collapse: collapse; margin-top: 20px;">
  <tr style="border: 1px solid #000;">
    <td style="padding: 5px;">
      <strong>Retention Score Verified By:</strong> (HRD STAFF NAME, SIGNATURE & DATE)
    </td>
  </tr>
</table>

<table style={{ width: '100%', fontWeight: 500, fontSize:"12px" }}>
  <tbody>
    <tr>
    <td></td>
    <td></td>
      <td style={{ textAlign: 'right', fontSize:"12px" }}>
        <strong>Department with * shows adhoc rows</strong>
      </td>
    </tr>
  </tbody>
</table>

`}
                      ></TelerikDataTable>
                    )}
                  </div>
                </AccordionDetails>
              </Accordion>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <div style={borderStyle}>
        <div style={rowStyle}>
          <div>
            <p style={{ margin: "5px 0" }}>
              <strong>Prior Mil:</strong> {results?.[0]?.Psmil_Yy ?? 0} Years{" "}
              {results?.[0]?.Psmil_Mm ?? 0} Months {results?.[0]?.Psmil_Dd ?? 0}{" "}
              Days
            </p>
          </div>
          <div>
            <p style={{ margin: "5px 0" }}>
              <strong>Prior GovGuam Service:</strong> {results?.[0]?.Ps_Yy ?? 0}{" "}
              Years {results?.[0]?.Ps_Mm ?? 0} Months {results?.[0]?.Ps_Dd ?? 0}{" "}
              Days
            </p>
          </div>
        </div>
      </div>

      <div style={{ ...borderStyle, marginTop: "10px" }}>
        <div style={rowStyle}>
          <div>
            <p style={{ margin: "5px 0" }}>
              <strong>Total Actual GovGuam Service::</strong>{" "}
              {serviceData?.Years} Years {serviceData?.Months} Months{" "}
              {serviceData?.Days}{" "}
              Days
            </p>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <p style={{ margin: "2px 0" }}>
          <strong>EMPLOYMENT DATE:</strong>{" "}
          <span>{formatDate(modalData?.EmploymentDate)}</span>
        </p>
        <p style={{ margin: "2px 0" }}>
          <strong>Total Service Points:</strong> {(Years) * 12 + (Months)}
        </p>
        <p style={{ margin: "2px 0" }}>
          <strong>Total Performance Points:</strong>{" "}
          {modifiedModalData?.PerformancePoint}
        </p>
        <p style={{ margin: "2px 0" }}>
          <strong>Total Retention Points:</strong>{" "}
          {(Years) * 12 + (Months)  + modifiedModalData?.PerformancePoint}
        </p>
      </div>

      <div style={{ marginTop: "20px" }}>
        <p style={{ margin: "2px 0" }}>
          <strong>Retention Score Verified By:</strong> (HRD STAFF NAME,
          SIGNATURE & DATE)
        </p>
      </div>

      <div style={{display:"flex",flexDirection:"row-reverse", fontWeight:"bold"}}>
        <p>Deapartment with * shows adhoc rows</p>
      </div>

      <Modal open={addRecordModal} onClose={handleClose}>
        <Box
          sx={{
            width: 900, // Increased modal width
            p: 4,
            bgcolor: "background.paper",
            borderRadius: 2,
            mx: "auto",
            mt: "10%",
          }}
        >
          <Typography variant="h6" component="h2" mb={2}>
            Adhoc
          </Typography>

          <RetentionForm
            handleClose={handleClose}
            modalData={modalData}
            refreshDetail={refreshDetail}
            departmentOptions={departmentOptions}
            setAdHocPoint={setAdHocPoint}
            adHocPoint ={adHocPoint}
          />
        </Box>
      </Modal>
      {/* Reamrsk Modal */}
      <Modal
        open={remarksOpen}
        onClose={handleRemarksClose}
        aria-labelledby="modal-remarks-title"
        aria-describedby="modal-remarks-description"
      >
        <Box
          sx={{
            width: 400,
            p: 4,
            bgcolor: "background.paper",
            borderRadius: 2,
            mx: "auto",
            mt: "10%",
          }}
        >
          <Typography id="modal-remarks-title" variant="h6" component="h2">
            Remarks
          </Typography>
          <Typography id="modal-remarks-description" sx={{ mt: 2 }}>
            {remarksData}
          </Typography>
          <Box sx={{ mt: 3 }} style={{display:'flex', flexDirection:"row-reverse"}}>
            <Button
              onClick={handleRemarksClose}
              variant="contained"
              color="primary"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

// Inline styles
const headerStyle = {
  border: "1px solid #000",
  padding: "8px",
  backgroundColor: "#f2f2f2",
  textAlign: "center",
  fontWeight: "bold",
};

const cellStyle = {
  border: "1px solid #000",
  padding: "8px",
  textAlign: "center",
};

const borderStyle = {
  border: "1px solid #000",
  padding: "10px",
};

const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
};

export default RetentionWorksheet;
